var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"outlined":"","dense":"","label":_vm.$t('info_card.country'),"item-text":(item) => _vm.objectTranslator(item, 'NATION_NAME'),"items":_vm.countrys,"item-value":(item) => item.NATION_ID},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }